export default __webpack_public_path__ + "static/media/welcomeLogoActive.d91d3500.svg";